import React, { useState, useEffect } from 'react';

const S = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 99999,
    background: 'rgba(7,9,26,0.97)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Courier New', monospace",
  },
  card: {
    background: '#0d1520',
    border: '1px solid rgba(0,212,255,0.3)',
    borderRadius: '20px',
    padding: '40px 36px',
    width: '480px',
    maxWidth: '92vw',
  },
  logo: {
    textAlign: 'center',
    fontSize: '28px',
    fontWeight: '900',
    color: '#00d4ff',
    letterSpacing: '4px',
    marginBottom: '6px',
  },
  sub: {
    textAlign: 'center',
    fontSize: '12px',
    color: 'rgba(0,212,255,0.5)',
    letterSpacing: '3px',
    marginBottom: '32px',
  },
  label: {
    fontSize: '11px',
    color: 'rgba(255,255,255,0.5)',
    letterSpacing: '2px',
    marginBottom: '8px',
    display: 'block',
  },
  input: {
    width: '100%',
    background: 'rgba(0,0,0,0.5)',
    border: '1px solid rgba(0,212,255,0.25)',
    borderRadius: '10px',
    color: '#e2e8f0',
    fontSize: '14px',
    fontFamily: 'monospace',
    padding: '12px 14px',
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: '10px',
  },
  hint: {
    fontSize: '11px',
    color: 'rgba(255,255,255,0.35)',
    marginBottom: '24px',
    lineHeight: '1.6',
  },
  hintLink: {
    color: '#00d4ff',
    textDecoration: 'none',
  },
  btn: {
    width: '100%',
    padding: '14px',
    background: 'linear-gradient(135deg, #00d4ff, #0066cc)',
    border: 'none',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '700',
    letterSpacing: '2px',
    cursor: 'pointer',
    marginBottom: '12px',
  },
  btnDisabled: {
    opacity: 0.45,
    cursor: 'not-allowed',
  },
  error: {
    background: 'rgba(239,68,68,0.1)',
    border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: '8px',
    color: '#f87171',
    fontSize: '12px',
    padding: '10px 14px',
    marginBottom: '12px',
  },
  success: {
    background: 'rgba(16,185,129,0.1)',
    border: '1px solid rgba(16,185,129,0.3)',
    borderRadius: '8px',
    color: '#34d399',
    fontSize: '13px',
    padding: '10px 14px',
    marginBottom: '12px',
    textAlign: 'center',
  },
  step: {
    display: 'flex',
    gap: '10px',
    marginBottom: '6px',
    fontSize: '12px',
    color: 'rgba(255,255,255,0.4)',
  },
  stepNum: { color: '#00d4ff', flexShrink: 0 },
};

export default function ApiKeySetup() {
  const [visible,  setVisible]  = useState(false);
  const [apiKey,   setApiKey]   = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [success,  setSuccess]  = useState(false);

  useEffect(() => {
    // Only show in Electron desktop app
    if (!window.electronAPI?.isElectron) return;

    fetch('/api/config/status')
      .then(r => r.json())
      .then(d => { if (!d.hasApiKey) setVisible(true); })
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    const trimmed = apiKey.trim();
    if (!trimmed.startsWith('gsk_')) {
      setError('Key must start with gsk_ — get it free at groq.com');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res  = await fetch('/api/config/apikey', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ apiKey: trimmed }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Save failed');
      setSuccess(true);
      setTimeout(() => { setVisible(false); window.location.reload(); }, 1500);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  if (!visible) return null;

  return (
    <div style={S.overlay}>
      <div style={S.card}>
        <div style={S.logo}>JARVIS</div>
        <div style={S.sub}>TRADING AI — SETUP</div>

        <div style={{ marginBottom: '20px' }}>
          {[
            ['1.', 'groq.com वर जा → Sign Up (free)'],
            ['2.', 'Dashboard → API Keys → Create New Key'],
            ['3.','Key खाली paste करा → Save करा'],
          ].map(([n, t]) => (
            <div key={n} style={S.step}>
              <span style={S.stepNum}>{n}</span>
              <span>{t}</span>
            </div>
          ))}
        </div>

        <label style={S.label}>GROQ API KEY</label>
        <input
          type="password"
          style={S.input}
          placeholder="gsk_xxxxxxxxxxxxxxxxxxxx"
          value={apiKey}
          onChange={e => { setApiKey(e.target.value); setError(''); }}
          onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
          autoFocus
        />
        <div style={S.hint}>
          Free tier — 30,000 tokens/day. Key मिळवण्यासाठी:{' '}
          <a href="https://console.groq.com/keys" target="_blank" rel="noreferrer" style={S.hintLink}>
            console.groq.com/keys
          </a>
        </div>

        {error   && <div style={S.error}>❌ {error}</div>}
        {success && <div style={S.success}>✅ Key saved — JARVIS starting...</div>}

        <button
          style={{ ...S.btn, ...(loading || success ? S.btnDisabled : {}) }}
          onClick={handleSave}
          disabled={loading || success}
        >
          {loading ? 'SAVING...' : 'JARVIS LAUNCH करा →'}
        </button>

        <div style={{ textAlign: 'center', fontSize: '11px', color: 'rgba(255,255,255,0.2)', marginTop: '4px' }}>
          Key तुमच्याच PC वर save होतो — cloud ला जात नाही
        </div>
      </div>
    </div>
  );
}
